import axios from 'axios';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import LinkContainer from "./Link";
import NestedLink from "./NestedLink";

import { APP_VERSION, LANGUAGE_OPTIONS } from "../../constants";
import useApi from '../../hooks/useApi';
import { network_tl } from '../../translations';
import { customStringify, error_alert, removeToken, setAppLanguage, success_alert } from '../../utils';

import { logout } from '../../redux/slices/userSlice';
import { set_sidebar } from "../../redux/slices/uiSlice";

import { GoSignOut } from "react-icons/go";
import { BiLoaderAlt } from 'react-icons/bi';
import { GoSidebarCollapse } from "react-icons/go";
import { set_language } from '../../redux/slices/languageSlice';
import LanguageSelect from '../Filter/LanguageSelect';

const Sidebar = ({ links }) => {
    const intl = useIntl();
    const { Axios } = useApi();
    const dispatch = useDispatch();

    const { sidebar } = useSelector(state => state.ui);
    const lang = useSelector(state => state.language);

    const [language, setLanguage] = useState(lang);

    const handleLanguageChange = (value) => {
        setLanguage(value)
        dispatch(set_language(value))
        setAppLanguage(value.value)
    };

    const [loading, setLoading] = useState(false);

    const handleLogout = async () => {
        try {
            setLoading(true);
            const result = await Axios.get("api/user/logout");
            dispatch(logout());
            removeToken();
            success_alert(result.data.description);
            setLoading(false);
        } catch (e) {
            setLoading(false);
            if (axios.isCancel(e)) {
            }
            else if (e.response) {
                error_alert(customStringify(e.response.data.description));
            } else {
                error_alert(network_tl(intl));
            }
        }
    }

    return (
        <>
            {
                sidebar &&
                <div onClick={() => dispatch(set_sidebar(false))} className="block lg:hidden z-[109] fixed top-0 bottom-0 left-0 right-0 bg-gradient-to-t from-primary via-primary/60 to-black/50">

                </div>
            }
            <div className={`sidebar-gradient z-[110] transition-transform overflow-hidden  border-r-2 border-primary/10 flex flex-col fixed top-0 bottom-0 w-[230px] transform ${sidebar ? "translate-x-0" : "translate-x-[-100%]"}`}>
                <div className='flex-shrink-0 h-[70px] flex justify-between items-center w-[90%] mx-auto '>
                    <Link to={'/'} className='focus:outline-none'>
                        <img src="/images/logo.svg" alt="" className='w-[80px]' />
                    </Link>
                    <button
                        onClick={() => {
                            dispatch(set_sidebar(false))
                        }}
                        type={"button"}
                        className='mb-1 h-[40px] w-[40px] rounded-full hover:bg-primary/5 flex items-center justify-center'
                    >
                        <GoSidebarCollapse className='text-xl rotate-[180deg]' />
                    </button>

                </div>

                <div className="py-5 flex-grow space-y-1 overflow-y-auto">
                    <div className='h-full overflow-auto'>
                        {
                            links.map((item, index) => (
                                item.links ?
                                    <NestedLink key={index} title={item.title} Icon={item.Icon} to={item.to} links={item.links} />
                                    :
                                    <LinkContainer key={index} title={item.title} Icon={item.Icon} to={item.to} />

                            ))
                        }
                    </div>


                </div>

                <div className='flex flex-col items-center justify-center flex-shrink-0 py-5 border-t-2 border-primary/10'>

                    <button
                        disabled={loading}
                        onClick={() => handleLogout()}
                        className='w-[90%] rounded-[10px] hover:bg-primary group flex justify-between  py-3 px-4 items-center'
                    >
                        <span className='flex space-x-3 justify-start'>
                            <GoSignOut className='flex-shrink-0 group-hover:text-white text-primary/80 text-xl' />
                            <p className='text-sm font-medium group-hover:text-white text-primary/80'>
                                <FormattedMessage id="signout" defaultMessage={"Sign Out"} />
                            </p>
                        </span>
                        {
                            loading &&
                            <BiLoaderAlt className="animate-spin text-xl text-primary group-hover:text-white" />
                        }
                    </button>

                    {/* <p className='mt-5 text-center text-xs text-primary/50'>
                        {APP_VERSION} - <FormattedMessage id="development" defaultMessage={"development"} />
                    </p> */}
                    <p className='mt-5 text-center text-xs text-primary/50'>
                        {APP_VERSION}
                         {/* - <FormattedMessage id="development" defaultMessage={"development"} /> */}
                    </p>

                    <div className='w-[125px] block sm:hidden'>
                        <LanguageSelect
                            // label_text={<FormattedMessage id='select_lang' defaultMessage={"Select Language"} />}
                            options={LANGUAGE_OPTIONS}
                            state={language}
                            setState={handleLanguageChange}
                            disableClearable={true}
                            disableSearch={true}
                            menuTop={true}
                        />
                    </div>
                </div>

            </div>
        </>
    )
}

export default Sidebar